/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-qiye" /> 企业列表 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>
      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div>
            <i-input
              prefix="ios-search"
              v-model="seachName"
              class="tabdiv"
              placeholder="搜索企业名称"
              style="width: 200px"
              @on-change="getCompanyInfo(1)"
            />
            <Select v-model="optId" style="width: 200px" @on-change="getCompanyInfo(1)">
              <Option v-for="item in optList" :value="item.id" :key="item.id">{{ item.label }}</Option>
            </Select>
          </div>
          <div></div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :columns="columns2" :data="companylist" :loading="tbLoading" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          show-total
          :total="total"
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200, 500]"
          :page-size="row"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>
    </X-Layout>
  </div>
</template>

<script>
import { checkOptionList } from '@/utils/common';
export default {
  data() {
    return {
      optId: -1,
      // 0工况 1油烟 2在线
      optList: checkOptionList,
      seachName: '', // 搜索公司名
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      value: '',
      total: 0,
      page: 1,
      row: 20,
      select: 1,
      tbLoading: false, // 表格加载动画
      columns2: [
        {
          type: 'index',
          title: '序号',
          width: 70,
          align: 'center',
          indexMethod: row => {
            return row._index + 1 + (this.page - 1) * this.row;
          },
        },
        {
          title: '企业名称',
          key: 'company_name',
          align: 'center',
          minWidth: 180,
          sortable: true,
        },
        {
          title: '地址',
          key: 'address',
          align: 'center',
          minWidth: 200,
        },
        {
          title: '联系人',
          key: 'legalPerson',
          align: 'center',
          width: 80,
        },
        {
          title: '联系方式',
          key: 'phone',
          align: 'center',
          width: 130,
        },
        {
          title: '行业',
          key: 'industry',
          align: 'center',
          width: 120,
          sortable: true,
        },
        {
          title: '创建日期',
          key: 'time',
          align: 'center',
          width: 120,
          sortable: true,
          render: (h, params) => {
            let time = params.row.time || '';
            if (time) {
              time = this.formatDateTime1(time);
            }
            return h('span', {}, time);
          },
        },
        {
          title: '监测项',
          align: 'center',
          width: 100,
          sortable: true,
          render: (h, params) => {
            let thisshow = params.row.sitesName;

            if (thisshow) {
              // 不为空的 才输出格式
              let _color;
              switch (thisshow) {
                case '工况':
                  _color = 'blue';
                  break;
                case '油烟':
                  _color = 'green';
                  break;
                case '视频':
                  _color = 'purple';
                  break;
                case '在线':
                  _color = 'yellow';
                  break;
              }
              return h('Tag', { props: { color: _color } }, thisshow);
            }
          },
        },
      ],
      companylist: [],
    };
  },

  mounted() {
    this.getCompanyInfo(1);
  },
  methods: {
    /**
     * 获取公司信息
     */
    getCompanyInfo(page) {
      this.select = 1;
      const api = this.ApiUrl + 'company/findAllCompany';
      const params = {
        pageNo: page,
        pageSize: this.row,
        companyName: this.seachName || '',
      };

      if (this.optId != -1) {
        params.type = this.optId;
      }

      this.tbLoading = true; // 开启加载动画
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            this.page = page;
            this.companylist = res.data.extend.pageInfo.records;
            this.total = res.data.extend.pageInfo.total;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },
    getCompanynameInfo() {
      this.select = 2;
      const api = this.ApiUrl + 'company/findAllCompanyLike';
      const data = {
        page: this.page,
        row: this.row,
        company_name: this.seachName,
      };
      this.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.companylist = res.data.extend.pageInfo;
            this.total = res.data.extend.total1;
            this.page = res.data.extend.page;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },

    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getCompanyInfo(1);
    },
    // 切换下一页
    onNextPage(e) {
      this.getCompanyInfo(e);
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-right: 1.25rem;
}
</style>
